<template>
  <div v-if="hasVideoUrl">
    <div>
      <p><strong>{{ $t('posts.networks.videoTitre') }}</strong></p>
    </div>
    <p>{{ $t('posts.networks.videoTexte') }}</p>
    <el-form-item :error="inputError">
      <el-row>
        <el-col :span="24">
          <el-input v-model="postVideoFileUrlCustom" type="url" @change="savePostVideoUrl" :disabled="(data.statusPost === 'isCurrentlyPublished') || data.isCurrentlyPublished || (data.statusPost === 'published')"></el-input>
        </el-col>
      </el-row>
    </el-form-item>
    <div v-if="possedeClapVideo">
      <div v-if="this.data.post.url_clap">
        <el-button @click="copyClap" type="primary">{{ $t('posts.networks.videoButtonClap') }}</el-button>
      </div>
      <div v-else-if="this.user.possedeClap">
        <p>
          <span>{{ $t('posts.networks.videoButtonGotoClap') }} </span>
          <a @click="goToClap" style="text-decoration: underline; cursor: pointer;"><strong>Flow vidéo</strong></a>
        </p>
      </div>
      <br />
    </div>
  </div>
</template>

<script>

import { $t } from '@/i18n'

export default {
  name: 'PostVideoFileUrlCustom',
  props: { data: Object },
  data () {
    return {
      hasVideoUrl: false,
      postVideoFileUrlCustom: '',
      inputError: ''
    }
  },
  computed: {
    sitimmoUser () {
      return this.$store.state.app.sitimmoUser
    },
    user () {
      return this.$store.state.app.user
    },
    possedeClapVideo () {
      return this.user.possedeClap
    }
  },
  methods: {
    savePostVideoUrl () {
      this.inputError = ''
      if (this.postVideoFileUrlCustom) {
        const urlVideo = this.urlIsValid(this.postVideoFileUrlCustom)
        if (!urlVideo) {
          this.inputError = $t('posts.networks.videoUrlError')
          this.$emit('updateValue', 'invalidUrl', this.inputError)
          this.$message({ message: $t('posts.networks.videoUrlError'), type: 'error', duration: 4000 })
          return false
        }
      }
      this.$emit('updateValue', 'invalidUrl', 'delete')
      if (!this.data.post.post_video_file_url_custom) {
        this.data.post.post_video_file_url_custom = {}
      }
      const diffuseurClef = this.data.networkName.toLowerCase()
      this.data.post.post_video_file_url_custom[diffuseurClef] = this.postVideoFileUrlCustom
    },
    urlIsValid (urlString) {
      let isValid = false
      try {
        const urlVideo = new URL(urlString)
        isValid = (
          ((urlVideo.protocol === 'http:') || (urlVideo.protocol === 'https:')) &&
          (urlVideo.hostname.indexOf('youtube') === -1) &&
          (urlVideo.hostname.indexOf('dailymotion') === -1)
        )
      } catch (_) {
      }
      return isValid
    },
    copyClap () {
      this.postVideoFileUrlCustom = this.data.post.url_clap
      this.savePostVideoUrl()
    },
    goToClap () {
      this.$emit('change-tab', 'Video')
    }
  },
  beforeMount () {
    if (this.sitimmoUser.optionVideo) {
      this.hasVideoUrl = true
    }
  },
  mounted () {
    const diffuseurClef = this.data.networkName.toLowerCase()
    if (diffuseurClef) {
      if (this.data.post.post_video_file_url_custom && this.data.post.post_video_file_url_custom[diffuseurClef]) {
        this.postVideoFileUrlCustom = this.data.post.post_video_file_url_custom[diffuseurClef]
      }
    }
  }
}
</script>

<style lang="scss">
</style>
